import { render, staticRenderFns } from "./DraftProject.vue?vue&type=template&id=7db822cf&"
import script from "./DraftProject.vue?vue&type=script&lang=js&"
export * from "./DraftProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports